import { useSyncExternalStore } from 'react';

/** One 1s ticker shared by every countdown; the interval runs only while a countdown is mounted. */
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | undefined;
let now = Date.now();

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);

  if (!timer) {
    timer = setInterval(() => {
      now = Date.now();
      listeners.forEach((notify) => notify());
    }, 1000);
  }

  return () => {
    listeners.delete(listener);

    if (listeners.size === 0 && timer) {
      clearInterval(timer);
      timer = undefined;
    }
  };
};

export const useSecondTick = (): number =>
  useSyncExternalStore(
    subscribe,
    () => now,
    () => now,
  );
